import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";

import './FolhaStatusPagamentos.css'

import { useAuth } from "../../../hooks/useAuth";
import { usePayroll } from "../../../hooks/usePayroll";
import { formatValueToMonetary } from "../../../utils/formatter";
import { PageHeader } from "../../page-header";

export default function () {
  const { user } = useAuth()
  const { getDetailedPayroll, detailedPayroll, loading, getHolerite, sendHoletireByEmail } = usePayroll();
  const { payrollId } = useParams();
  const [filteredCollaborators, setFilteredCollaborators] = useState([]);

  const handleSendHoletireByEmail = async (payrollItemSnapshotId) => {
    await sendHoletireByEmail(payrollItemSnapshotId);
  }

  const getTotalCollaborators = () => {
    return detailedPayroll?.items?.length || 0;
  }

  const getTotalPaidCollaborators = () => {
    return detailedPayroll?.items?.filter(item => item.payment[0]?.status === "PAID")?.length || 0;
  }

  const getTotalUnpaidCollaborators = () => {
    return detailedPayroll?.items?.filter(item => item.payment[0]?.status !== "PAID")?.length || 0;
  }

  const getTotalPaidAmount = () => {
    return formatValueToMonetary(detailedPayroll?.items?.reduce((acc, item) => acc + (item.payment[0]?.status === "PAID" ? item.netAmount : 0), 0) || 0);
  }

  const getTotalUnpaidAmount = () => {
    return formatValueToMonetary(detailedPayroll?.items?.reduce((acc, item) => acc + (item.payment[0]?.status !== "PAID" ? item.netAmount : 0), 0) || 0);
  }

  const mapStatusToLabel = (status) => {
    const map = {
      PAID: 'FOLHA PAGA',
      PARTIAL: "FOLHA PAGA PARCIALMENTE",
    };

    return map[status] || status;
  }

  const collaboratorStatusMap = {
    PAID: 'Pago',
    PENDING: 'Pendente',
    FAILED: 'Falhou',
  };

  useEffect(() => {
    if (payrollId) {
      getDetailedPayroll(payrollId);
    }
  }, [payrollId]);

  useEffect(() => {
    setFilteredCollaborators(detailedPayroll?.items || []);
  }, [detailedPayroll]);

  return (
    <div className="preview-container">
      <div className="col-md-10">
        <div className="mt-4 mb-3">
          <PageHeader title="Status de pagamentos" pages={[{ name: 'Status de pagamentos', link: "/folha-pagamento/previa" }]} />
        </div>
        <section id="screen-preview" className="screen active screen-preview">
          <p className="subtitle">Revise os valores antes de fechar a folha e enviar para pagamento. Envie também o comprovante de pagamento para o e-mail do colaborador. </p>
          <div className="filters-row payroll-actions-row">
            <div className="d-flex flex-column gap-2">
              <span className="payroll-label">Competência: {moment(`${detailedPayroll?.payroll.referenceMonth}-${detailedPayroll?.payroll.referenceYear}`, "MM-YYYY").format("MMMM YYYY")}</span>
              <span className="payroll-label">Status: {mapStatusToLabel(detailedPayroll?.payroll.status)}</span>
            </div>
          </div>

          <div className="cards-row">
            <div className="preview-card">
              <div className="card-title">Total Colaboradores</div>
              <div className="card-value">{getTotalCollaborators()}</div>
            </div>
            <div className="preview-card">
              <div className="card-title">Colaboradores Pagos</div>
              <div className="card-value">{getTotalPaidCollaborators()}</div>
            </div>
            <div className="preview-card">
              <div className="card-title">Colaboradores Não Pagos</div>
              <div className="card-value">{getTotalUnpaidCollaborators()}</div>
            </div>
            <div className="preview-card">
              <div className="card-title">Valor Pago</div>
              <div className="card-value">{getTotalPaidAmount()}</div>
            </div>
            <div className="preview-card">
              <div className="card-title">Valor Pendente</div>
              <div className="card-value">{getTotalUnpaidAmount()}</div>
            </div>
          </div>
          <div className="preview-collaborator-table-content">
            <table className="preview-collaborator-table">
              <thead>
                <tr>
                  <th>Colaborador</th>
                  <th>Vínculo</th>
                  <th>Base</th>
                  <th>Descontos</th>
                  <th>Líquido</th>
                  <th>Status Pagamento</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {
                  filteredCollaborators?.map(c => {
                    return (
                      <tr key={c.id}>
                        <td>{c.collaborator?.name}</td>
                        <td>{c.collaborator?.employmentType}</td>
                        <td>{formatValueToMonetary(c.grossAmount)}</td>
                        <td>{formatValueToMonetary(c.discountAmount)}</td>
                        <td>{formatValueToMonetary(c.netAmount)}</td>
                        <td><span className={collaboratorStatusMap[c.payment[0]?.status] === 'Pago' ? 'status-ok' : collaboratorStatusMap[c.payment[0]?.status] === 'Falhou' ? 'status-failed' : ''}>{collaboratorStatusMap[c.payment[0]?.status] || 'Pendente'}</span></td>
                        <td className="payroll-actions-cell">
                          {
                              ["PAID"].includes(c.payment[0]?.status) ?
                            <>
                              <a role="button" className="payroll-action-link" onClick={() => loading ? null : getHolerite(c.snapshotId)}>
                                {
                                  loading ? "Baixando..." : "Baixar holerite"
                                }
                              </a>

                              <button className="payroll-secondary-action" onClick={() => loading ? null : handleSendHoletireByEmail(c.snapshotId)}>
                                {
                                  loading ? "Enviando..." : "Enviar comprovante por e-mail"
                                }
                              </button>
                            </>
                            :
                            <span> - </span>
                          }
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}
